// Checkpoint quizzes: the class pauses at the lesson's quiz (or recap) chapter and Zoya Ma'am asks 3 questions.
// Questions come from the server and answers are checked there, so stars can't be faked.
import { api } from "@/lib/api";
import { authHeader } from "@/lib/aadhaar";

const studentAuth = () => (localStorage.getItem("rs_student_token") ? authHeader("student") : undefined);
export const fetchQuiz = (slug) => api.get(`/classroom/quiz/${slug}`).then((r) => r.data.questions);
export const checkAnswer = (slug, q, choice) => api.post(`/classroom/quiz/${slug}/answer`, { q, choice }, studentAuth()).then((r) => r.data);

export const quizChapter = (lesson) =>
  lesson.chapters.find((c) => /quiz/i.test(c.title)) || lesson.chapters.find((c) => /recap/i.test(c.title));

const STARS = "rs_classroom_stars";
export const getStars = () => { try { return JSON.parse(localStorage.getItem(STARS) || "{}"); } catch { return {}; } };
export const saveStars = (slug, n) => localStorage.setItem(STARS, JSON.stringify({ ...getStars(), [slug]: Math.max(n, getStars()[slug] || 0) }));
